import { convertFeeInMinUnitToMainUnitFixed } from '../../../../common/utils/fee.helper';
import { ReuseCardsEvent } from '../../models/reuse-card-events-response';

export const mapEventNameToDisplayName = (eventName: ReuseCardsEvent): string => {
  switch (eventName) {
    case ReuseCardsEvent.CREATE_REUSE_CARD:
      return 'CREATE';
    case ReuseCardsEvent.UPDATE_REUSE_CARD:
      return 'UPDATE';
    default:
      return eventName;
  }
};

export const getTableMonetaryValue = (monetaryValue: number | undefined): string | undefined => {
  return monetaryValue ? convertFeeInMinUnitToMainUnitFixed(monetaryValue) : undefined;
};
